import React, { useEffect } from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import useAuthV2 from "./useAuthV2";
import { Loader } from "app";

const BidderAuthWrapperV2 = function (props: { children: any }) {
  const { token, authCheckComplete } = useAuthV2();
  // console.log("authCheckComplete", authCheckComplete, token);
  if (!authCheckComplete || !token) {
    return (
      <main className="justify-center max-w-7xl mx-auto flex flex-col items-center min-h-screen">
        <Loader height="h-16" width="w-16" color="text-brand-orange" />
      </main>
    );
  } else if (token && token?.isLoggedIn === false) {
    return <div>{props.children}</div>;
  } else {
    return <div>{props.children}</div>;
  }
};

export default BidderAuthWrapperV2;
